<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div slot="content" class="d-flex flex-row">
      <!-- 标题栏和状态栏占位符 -->
      <div
        v-if="data[0]"
        class="flex-1 content"
        :style="{backgroundColor:pattern.cardBackgroundColor}"
      >
        <div class="title">{{data[0].title}}</div>
        <div class="subTitle">{{data[0].subTitle}}</div>
        <div class="d-flex flex-row">
          <van-image lazy-load
            v-if="data[0].list[0]"
            :src="data[0].list[0].src"
            class="flex-1 image"
            :class="{'img-radius':pattern.showImgBorderRadius}"
            @click="navToDetailPage(data[0].list[0])"
          />
          <div style="width:10px"></div>
          <van-image lazy-load
            v-if="data[0].list[1]"
            :src="data[0].list[1].src"
            class="flex-1 image"
            :class="{'img-radius':pattern.showImgBorderRadius}"
            @click="navToDetailPage(data[0].list[1])"
          />
        </div>
      </div>
      <div v-if="data[1]" :class="{width:pattern.showSpace}"></div>
      <div class="flex-1 content" :style="{backgroundColor:pattern.cardBackgroundColor}">
        <div class="title">{{data[1].title}}</div>
        <div class="subTitle">{{data[1].subTitle}}</div>
        <div class="d-flex flex-row">
          <van-image lazy-load
            v-if="data[1].list[0]"
            :src="data[1].list[0].src"
            class="flex-1 image"
            :class="{'img-radius':pattern.showImgBorderRadius}"
            @click="navToDetailPage(data[1].list[0])"
          />
          <div style="width:10px"></div>
          <van-image lazy-load
            v-if="data[1].list[1]"
            :src="data[1].list[1].src"
            class="flex-1 image"
            :class="{'img-radius':pattern.showImgBorderRadius}"
            @click="navToDetailPage(data[1].list[1])"
          />
        </div>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Array,
      default: () => {
        return [
          {
            title: '进口海产',
            subTitle: '高蛋白波士顿龙虾',
            list: [{
              src: '',
              navTo: ''
            }, {
              src: '',
              navTo: ''
            }]
          },
          {
            title: '产地量贩',
            subTitle: '海鲜拼盘限量49.9元',
            list: [{
              src: '',
              navTo: ''
            }, {
              src: '',
              navTo: ''
            }]
          }
        ]
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: true,
          showRightBorder: true,
          showBottomBorder: true,
          showLeftBorder: true,
          showBorderRadius: true,
          showLeftPadding: false,
          showRightPadding: false,
          showTopPadding: false,
          showBottomPadding: false,
          showSpace: true,
          showImgBorderRadius: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,0)',
          cardBackgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}
.content {
  padding: 10px;
}
.width {
  width: 5px;
}
.img-radius {
  border-radius: 10px;
  overflow: hidden;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.subTitle {
  font-size: 12px;
  margin-bottom: 10px;
  color: grey;
}
.image {
  min-height: 70px;
}
</style>
